export class AccountType {
  public id?: string;
  public name: string;
}
